function fetchBooksPending() {
  return {
    type: 'FETCHING_BOOKS',
  };
}

function fetchBooksSuccess(books) {
  return {
    type: 'FETCHED_BOOKS',
    books,
  };
}

function fetchBooksError(error) {
  return {
    type: 'FETCHING_BOOKS_FAILED',
    error,
  };
}

function fetchOneBookPending() {
  return {
    type: 'FETCHING_ONE_BOOK',
  };
}

function fetchOneBookSuccess(book) {
  return {
    type: 'FETCHED_ONE_BOOK',
    book,
  };
}

function fetchOneBookError(error) {
  return {
    type: 'FETCHING_ONE_BOOK_FAILED',
    error,
  };
}

function signingUp() {
  return {
    type: 'SIGNING_UP',
  };
}

function signUpSuccess(user) {
  return {
    type: 'SIGNED_UP_SUCCESFUL',
    user,
  };
}

function signUpError(error) {
  return {
    type: 'SIGNED_UP_FAILURE',
    error,
  };
}

function loggingIn() {
  return {
    type: 'LOGGING_IN',
  };
}

function logInSuccess(user) {
  return {
    type: 'LOGGING_IN_SUCCESFUL',
    user,
  };
}

function logInError(error) {
  return {
    type: 'LOGGING_IN_FAILURE',
    error,
  };
}

function userIsLoggedInFalse() {
  return {
    type: 'CHECK_LOGIN_STATUS_FAIL',
  };
}

function userIsLoggedIn(user) {
  return {
    type: 'CHECK_LOGIN_STATUS',
    user,
  };
}

function userIsLoggedOut(status) {
  return {
    type: 'LOG_OUT_USER',
    status,
  };
}

function getFavouriteBooks(books) {
  return {
    type: 'FETCHED_FAVOURITES',
    books,
  };
}

function getFavouriteBooksSuccess(status) {
  return {
    type: 'FETCHED_FAVOURITES_SUCCESSFUL',
    status,
  };
}

export {
  fetchBooksPending,
  fetchBooksSuccess,
  fetchBooksError,
  fetchOneBookPending,
  fetchOneBookSuccess,
  fetchOneBookError,
  signingUp,
  signUpSuccess,
  signUpError,
  loggingIn,
  logInSuccess,
  logInError,
  userIsLoggedIn,
  userIsLoggedInFalse,
  userIsLoggedOut,
  getFavouriteBooks,
  getFavouriteBooksSuccess,
};
